module.exports = __webpack_public_path__ + "static/media/concert-2.small.50a93b7a.png";